module.exports = __webpack_public_path__ + "img/ref-4.7d0a4351.jpeg";